<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">
          Save solution in my cloud account
          <tooltip
            :content="
              'Please note, storing your data is offered as a service. <br />We are not responsible for data loss of any kind, like - but not limited to - server crash, tool’s functionality update or addition, phase-out of older products. <br />When intension is to have data stored over a long period of time it is recommended to download a copy to an alternative location that you can access outside of this tool.'
            "
          />
        </h5>
        <p class="component-paragraph">
          Please give this solution a name:
        </p>

        <label for="filename">Name</label>
        <input
          type="text"
          class="form-control"
          id="filename"
          name="filename"
          v-model="filename"
        />
        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Cancel"
            @click="clickedCancel"
          />
          <input
            type="submit"
            class="btn btn-secondary"
            value="Save"
            :disabled="saveDisabled"
            @click="clickedSave"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "SaveSolutionModal",
  data() {
    return {
      show: true,
      filename: this.initialFilename
    };
  },
  props: ["initialFilename"],
  methods: {
    clickedSave() {
      if (this.saveDisabled) return;
      this.$emit("onSaveSolution", this.filename);
      this.show = false;
    },
    clickedCancel() {
      this.show = false;
    }
  },
  computed: {
    saveDisabled() {
      return !this.filename; //cast to boolean
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
